import { AfterViewInit, ChangeDetectorRef, Component, inject, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs';
import { GungTabChangeEvent, GungTabsetComponent } from 'gung-common';
import { GungModalService } from '../../services/gung-modal/gung-modal.service';
import { GungSettingsConfigService, GungSettingsMenuItem } from '../../services/gung-settings-config.service';
import { GungSettingsBaseViewComponent } from '../gung-settings-base-view/gung-settings-base-view.component';

@Component({
    selector: 'lib-gung-settings',
    templateUrl: './gung-settings.component.html',
    styleUrls: ['./gung-settings.component.css'],
    standalone: false
})
export class GungSettingsComponent implements AfterViewInit {
  protected router = inject(Router);
  protected gungSettingsConfigService = inject(GungSettingsConfigService);
  protected gungModalService = inject(GungModalService);
  protected changeDetectorRef = inject(ChangeDetectorRef);
  protected activatedRoute = inject(ActivatedRoute);

  @ViewChild(GungTabsetComponent) protected tabsetRef: GungTabsetComponent;
  @ViewChildren(NgComponentOutlet) protected outlets: QueryList<NgComponentOutlet>;

  public gungSettingsMenu: GungSettingsMenuItem[] = [];
  public activeTabId: string = '';

  ngAfterViewInit(): void {
    this.gungSettingsConfigService.getGungSettingsMenu().pipe(first()).subscribe(menu => {
      this.gungSettingsMenu = menu;

      if (this.gungSettingsMenu.length > 0) {
        this.activeTabId = this.getInitialTabId();
        this.navigateToTab(this.activeTabId);
      } else {
        this.router.navigate(['']);
      }
      this.changeDetectorRef.detectChanges();
    });
  }

  public onTabChange(event: GungTabChangeEvent): void {
    const currentInstance = this.outlets.first?.componentInstance as GungSettingsBaseViewComponent | undefined;
    if (currentInstance?.unsavedChanges) {
      event.preventDefault();
      this.gungModalService.openConfirmYesNoModal('UNSAVED_CHANGES_HEADING', 'UNSAVED_CHANGES_CONTENT', undefined, 'CONTINUE', 'CANCEL').then(
        result => {
          if (result) {
            this.activeTabId = event.nextId;
            this.navigateToTab(event.nextId);
            this.changeDetectorRef.detectChanges();
          }
        },
        () => {}
      );
    } else {
      this.activeTabId = event.nextId;
      this.navigateToTab(event.nextId);
    }
  }

  protected navigateToTab(tabId: string): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { tab: tabId },
      queryParamsHandling: 'merge'
    });
  }

  protected getInitialTabId(): string {
    const tabParam = this.activatedRoute?.snapshot?.parent?.queryParams?.['tab'];
    if (tabParam && this.gungSettingsMenu.some(i => i.id === tabParam)) {
      return tabParam;
    }
    return this.gungSettingsMenu.find(i => !i.hide && !i.disabled)?.id ?? '';
  }
}
